module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Celcium-afd3264a8d96129c0f5007fbbe8383ec.svg";